import React from 'react'
import useBlogBink from '../useBlogBink'

interface BlogFilterProps {
  id: string
  children: React.ReactNode
  className?: string
}

export const BlogFilter: React.FC<BlogFilterProps> = ({
  children,
  id,
  className = '',
}) => {
  const blogBink = useBlogBink()

  return (
    <button
      className={`${className} blog-bink-filter`}
      type="button"
      data-active={blogBink.isSelected(id) ? 1 : 0}
      onClick={() => {
        blogBink.setSelectedFilters(id)
      }}
      tabIndex={0}
    >
      {children}
    </button>
  )
}

export default BlogFilter
